import React, {createRef} from 'react';

import "./textfield.css"

const TextfieldEssentiel = (props) => {

    const refTextfield = createRef();

    function EventChange(refPassed, value) {
        if (props.type === "number" && value !== "" &&
            (!/^\d+(?:\.\d*)?$/.test(value) || !Number.isFinite(Number(value)) || Number(value) > Number.MAX_SAFE_INTEGER)) {
            return;
        }
        // console.log("my vall " +  value)
        props.handleChange(props.setter, value) // launch handleChange in parent simu
    }

    return (
        <input type={props.type} className={"emol_prop_input"} value={props.value}  ref={refTextfield} placeholder={props.placeholder}
               min={props.type === "number" ? 0 : undefined}
               onWheel={props.type === "number" ? (event) => event.currentTarget.blur() : undefined}
               onKeyDown={(event) => {
                   if (props.type === "number" && event.key === "-") {
                       event.preventDefault();
                   }
               }}
               onChange={((e) => {
                   EventChange(refTextfield, e.target.value)
                   //props.editable ? EventChange(refTextfield, e.target.value) : <></>
               })}
        />

    );
};

export default TextfieldEssentiel;
